import { render } from "./SelectResources.vue?vue&type=template&id=1a6296ae&ts=true"
import script from "./SelectResources.vue?vue&type=script&lang=ts"
export * from "./SelectResources.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__